var layoutTemplate = require('@/modules/components/short-video.handlebars')
var videoTemplate = require('@/modules/components/video-wrapper.handlebars')
import CloseIcon from '@/assets/media/icons/close.svg'
import CTAIcon from '@/assets/media/icons/cta-overlay.svg'
import DangerIcon from '@/assets/media/icons/danger.svg'
import FullscreenIcon from '@/assets/media/icons/fullscreen.svg'
import LogoIcon from '@/assets/media/icons/logo.svg'
import UnMuteIcon from '@/assets/media/icons/muted.svg'
import MuteIcon from '@/assets/media/icons/volume.svg'
import PauseIcon from '@/assets/media/icons/pause-screen.svg'
import PipIcon from '@/assets/media/icons/pip.svg'
import PlayingIcon from '@/assets/media/icons/play.svg'
import PollIcon from '@/assets/media/icons/poll-overlay.svg'
import QuestionIcon from '@/assets/media/icons/question-overlay.svg'
import ShareIcon from '@/assets/media/icons/share.svg'
import LikeIcon from '@/assets/media/icons/like.svg'
import LikedIcon from '@/assets/media/icons/liked.svg'
import PlayRectIcon from '@/assets/media/icons/play-rect.svg'
import { OVERLAY_TYPE, PLAYLIST_TYPE, SHORT_VIDEO_TRACKING_TYPE } from '@/configs/constants'
import GlobalSettings from '@/core/global-settings'
import LoraCTA from './js/cta'
import LoraPoll from './js/poll'
import LoraQuestionAndAnswer from './js/qa'
import { CartIntegration } from './cart-integration'
import { initialModalState, resetAllState } from '~/store/cart'
import Cookies from 'js-cookie'
const helper = require('@/helpers/index.js')
import {
    TIMEOUT_TRACKING,
    ECOMMERCE_SITE,
    MANUAL_CART_EVENTS,
    DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
} from '@/configs/settings'
import shopifyCart from '~/services/shopify-cart'
import EventManager from '@/core/event-manager'
import { $appContext, $videoPlayingIndex, getContextValueByKey, updateAppContext } from '~/store/app-context'
import { ANALYTICS_EVENT } from '~/configs/analytics'
import manualCart from '~/services/manual-cart'
// import { db } from '@/services/db'
import { v4 as uuidv4 } from 'uuid'

class ShortVideo extends HTMLElement {
    static get observedAttributes() {
        return [
            'autoplay',
            'item-width',
            'video-height',
            'loop',
            'muted',
            'fullscreen',
            'group',
            'simple',
            'lazyload',
            'custom-height',
            'video-type',
            'url',
            'processing',
            'prev-index',
            'next-index',
            'enable-fullscreen',
            'pip-style',
            'active-index',
            'uuid',
            'disable-tracking',
            'tag-name',
            'fs-force-new-tab',
            'min-h-btns',
            'is-liked-video',
            'enable-like-button',
            'display-like-count',
            'total-like',
        ]
    }
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.eventManager = new EventManager()
        this.calculatorLayoutFunction = null
        this.playingIcon = PlayingIcon
        this.pauseIcon = PauseIcon
        this.muteIcon = UnMuteIcon
        this.unMuteIcon = MuteIcon
        this.fullscreenIcon = FullscreenIcon
        this.pipIcon = PipIcon
        this.closeIcon = CloseIcon
        this.shareIcon = ShareIcon
        this.likedIcon = LikedIcon
        this.likeIcon = LikeIcon
        this.logoIcon = LogoIcon
        this.dangerIcon = DangerIcon
        this.questionIcon = QuestionIcon
        this.pollIcon = PollIcon
        this.ctaIcon = CTAIcon
        this.playRectIcon = PlayRectIcon
        this.isGrabbing = false
        this.loaded = false
        this.videoType = null
        this.videoTypeIcon = null
        this.isCurrentOrigin = window.location.origin === process.env.SHORT_VIDEO_ORIGIN

        // CTA
        this._ctaDetail = {}
        this._ctaInstance = null

        // POLL
        this._pollDetail = {}
        this._pollInstance = null

        // Q&A
        this._qaDetail = {}
        this._qaInstance = null

        // Video
        this._videoItem = null
        this.durationString = ''
        this.duration = 0
        this.isSeekingVideo = false

        // Tracking
        this.trackingViewTimer = null

        this.playlistType = null
        this.maxVideos = null

        this.lazyload = true
        this.renderedVideo = false
        this.cartInstance = null
        this.meetsMinHeightForFullscreen = true

        this.isPip = false
        this.uuid = null
        this.unsubscribeAppContext = $appContext.subscribe((value) => {
            if (value.video.muted !== this.muted) {
                this.muted = value.video.muted
            }
            this.checkIsInPipMode()
        })

        // Landscape mode
        this.isPortrait = true
        this.videoWidthDimension = 0
        this.videoHeightDimension = 0

        this.unsubscribeCurrentPlayingIndex = undefined
        this.currentPlayingIndex = -1
        this.isInteracting = false
        this.isHidingThumbnail = false
        this.isPlayed = false
        this.hasCalledImpression = false // Flag to track API call
        this.activeIndex = undefined
        this.disableTracking = false
        this.organizationId = null
        this.isDisplaying = false
        this.pipInfo = {
            isMuted: true,
            isPlaying: false,
        }
        this.isLikedVideo = false
    }

    checkImageAndObserve() {
        const featureImage = this.featureImage // Assuming `featureImage` is the background image URL
        const bgElement = this.shadowRoot.querySelector('.lora-short__bg')

        if (!featureImage || !bgElement) return

        // Step 1: Check if the background image loads successfully
        const img = new Image()
        img.src = featureImage
        img.onload = async () => {
            this.registerIntersectionObserver(bgElement)
        }
        img.onerror = () => console.error('Error loading background image:', featureImage)
    }

    registerIntersectionObserver() {
        // Ensure Intersection Observer is initialized once
        this.intersectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (
                        !this.hasCalledImpression &&
                        (this.activeIndex === undefined || this.activeIndex === this.currentIndex) &&
                        !this.disableTracking &&
                        entry.isIntersecting &&
                        entry.intersectionRatio >= 0.75
                    ) {
                        this.callImpressionAPI()
                    }
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.7) {
                        this.isDisplaying = true
                        if (!this.disableTracking && this.autoplay && !this.pipInfo.isPlaying) {
                            if (this.lazyload) {
                                this.shadowRoot.dispatchEvent(
                                    new CustomEvent('fetch-detail', {
                                        detail: {},
                                        composed: true,
                                        bubbles: true,
                                    })
                                )
                            } else {
                                this.tryToPlayVideo()
                            }
                        }
                    } else {
                        this.isDisplaying = false
                    }
                })
            },
            { threshold: 0.75 } // Trigger when 75% of element is visible
        )

        this.intersectionObserver.observe(this)
    }

    callImpressionAPI() {
        let uuidTracking = `${this.videoId}_${this.uuid}`
        if (this.playlistId) {
            uuidTracking += `_${this.playlistId}`
        }
        const isChecked = GlobalSettings.isIdTracked(uuidTracking)
        if (!isChecked) {
            this.hasCalledImpression = true // Set flag to true
            const payloadData = {
                id: this.videoId,
                duration: parseInt(this.duration),
                uuid: this.uuid,
            }
            GlobalSettings.trackingIOT(
                SHORT_VIDEO_TRACKING_TYPE.IMPRESSION,
                this.playlistId,
                [payloadData],
                this.customTagName,
                this.organizationId
            )
        }
    }

    stopObseverTracking() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect()
        }
    }

    set videoItem(value) {
        this._videoItem = value
        if (this._videoItem?.organizationId) {
            this.organizationId = this._videoItem.organizationId
        }
        this.shadowRoot.dispatchEvent(
            new CustomEvent('sv-load', {
                detail: {},
                composed: true,
                bubbles: true,
            })
        )
    }

    get videoItem() {
        return this._videoItem
    }

    set ctaDetail(value) {
        this._ctaDetail = value
        if (!this.isSimple) {
            this.renderCTA()
            if (this._ctaDetail.useCartIntegration) {
                this.cartInstance = new CartIntegration({
                    videoId: this.videoId,
                    playlistId: this.playlistId,
                    products: this._ctaDetail.products,
                    organizationId: this.organizationId,
                    ecommerceSite: this._videoItem.ecommerceSite?.value,
                    viewBtnText: this._ctaDetail.urlName,
                })
                if (this._videoItem.ecommerceSite?.value === ECOMMERCE_SITE.SHOPIFY) {
                    shopifyCart.syncCartState()
                } else if (this._videoItem.ecommerceSite?.value === ECOMMERCE_SITE.OTHER) {
                    manualCart.syncCartState(this.videoId, this.playlistId)
                }
                this.renderCartIntegration()
            }
        }
    }

    get ctaDetail() {
        return this._ctaDetail
    }

    set pollDetail(value) {
        this._pollDetail = value
        if (!this.isSimple) {
            this.renderPoll()
        }
    }

    get pollDetail() {
        return this._pollDetail
    }

    set qaDetail(value) {
        this._qaDetail = value
        if (!this.isSimple) {
            this.renderQA()
        }
    }

    get qaDetail() {
        return this._qaDetail
    }

    toggleSound = (event) => {
        event.stopPropagation()
        this.videoElement.muted = !this.videoElement?.muted
        updateAppContext('video', { muted: this.videoElement?.muted })
        this.shadowRoot.dispatchEvent(
            new CustomEvent('update-sound-status', {
                detail: {
                    muted: this.videoElement?.muted,
                },
                composed: true,
                bubbles: true,
            })
        )
    }

    checkIsInPipMode() {
        if (this.isFullscreen) return
        const pipState = getContextValueByKey('pip')
        const overlayPip = this.shadowRoot.querySelector('.lora-short__pip-overlay')
        if (this.videoId !== pipState.videoId || (pipState.uuid && this.uuid !== pipState.uuid)) {
            this.updatePipStateOverlay(overlayPip)
        } else if (!this.isPip) {
            if (
                this.videoId === pipState.videoId &&
                ((!this.playlistId && !pipState.playlistId) || this.playlistId === pipState.playlistId) &&
                (!pipState.uuid || this.uuid == pipState.uuid)
            ) {
                if (!pipState.uuid) {
                    updateAppContext('pip', {
                        uuid: this.uuid,
                    })
                }
                this.updatePipStateOverlay(overlayPip, true)
            }
        }
    }

    updatePipStateOverlay(overlayPip, isPip = false) {
        this.isPip = isPip
        if (isPip) {
            if (overlayPip && overlayPip.classList.contains('lora--hidden')) {
                overlayPip.classList.remove('lora--hidden')
                if (this.videoElement) this.videoElement?.pause()
            }
        } else {
            if (overlayPip) overlayPip.classList.add('lora--hidden')
        }
    }

    showThankModal() {
        if (!this._qaInstance) {
            this._qaInstance = new LoraQuestionAndAnswer(this.shadowRoot, this._qaDetail)
        }
        this._qaInstance.showThankModal()
    }

    showFollowUpQuestion() {
        this._qaInstance.showFollowUpQuestion()
    }

    showFollowUpQuestionSyncState() {
        this._qaInstance.syncStateOpenModal()
        this._qaInstance.showFollowUpQuestion()
    }

    renderCartIntegration() {
        if (!this.cartInstance) return
        initialModalState(this.videoId)
        const loraShortVideo = this.shadowRoot.querySelector('.lora-short')
        loraShortVideo?.appendChild(this.cartInstance)
    }

    async renderCTA() {
        if (this.isSimple) {
            return
        }
        const videoTracking = {
            playlistId: this.playlistId,
            videoItem: [this.videoItem],
            tagName: this.wrapperLayout,
            orgId: this.organizationId,
        }
        this._ctaInstance = new LoraCTA(this.shadowRoot, {
            ...this._ctaDetail,
            isFullscreen: this.isFullscreen,
            videoId: this.videoId,
            playlistId: this.playlistId,
            videoTracking,
            organizationId: this.organizationId,
            isManualCart: this._videoItem.ecommerceSite?.value === ECOMMERCE_SITE.OTHER,
        })
        this._ctaInstance._clickedCallback = async ({ productDetailId, url, product, index }) => {
            this.shadowRoot.dispatchEvent(
                new CustomEvent('click-cta', {
                    detail: {
                        url,
                        productDetailId,
                        product,
                        index,
                    },
                    composed: true,
                    bubbles: true,
                })
            )
            if (this.videoItem.useCartIntegration && !this.isFullscreen && product?.isUsingCartIntegrated) {
                this.switchToFullscreen({
                    'product-detail-id': productDetailId,
                })
                return
            }

            const productUrl = new URL(url)
            if (productUrl.origin === window.location.origin) {
                if (this.isFullscreen) {
                    this.exitFullscreenMode()
                }
                // Create PIP and wait for it to complete
                await this.switchToPip()

                // After PIP is created, navigate to the new URL
                window.open(url, '_self')
            } else {
                window.open(url, '_blank')
            }
        }
        const isMultiple = this._ctaDetail.products ? this._ctaDetail.products.length > 1 : false

        // Update layout
        const actionRightLayout = this.shadowRoot.querySelector('.lora-short__overlay__mid-right.lora__actions')
        if (isMultiple) {
            actionRightLayout.classList.add('multiple')
        } else {
            actionRightLayout.classList.remove('multiple')
        }
    }

    async renderPoll() {
        if (!this._pollInstance) {
            this._pollInstance = new LoraPoll(this.shadowRoot, this._pollDetail)
        }

        if (this._pollDetail.result.answered) {
            this._pollInstance.updatePollData(this._pollDetail)
        } else {
            this.registerPollEvents()
        }
    }

    async registerPollEvents() {
        this._pollInstance._submittedCallback = (selected) => {
            this.shadowRoot.dispatchEvent(
                new CustomEvent('poll-submitted', {
                    detail: { selected },
                    composed: true,
                    bubbles: true,
                })
            )
            this.isInteracting = false
        }

        this._pollInstance._pollOptionClickCallback = () => {
            this.isInteracting = true
        }
    }

    async renderQA() {
        if (!this._qaInstance) {
            this._qaInstance = new LoraQuestionAndAnswer(this.shadowRoot, this._qaDetail)
        }
        this._qaInstance.answerClickedCallback = () => {
            this.shadowRoot.dispatchEvent(
                new CustomEvent('qa-answer-clicked', {
                    detail: {},
                    composed: true,
                    bubbles: true,
                })
            )
            this.shadowRoot.querySelector('.lora-short__overlay__mid-right.lora__actions').classList.add('lora--d-none')
        }

        this._qaInstance.answeredQuestionCallback = (answer) => {
            this.shadowRoot.dispatchEvent(
                new CustomEvent('qa-answered-question', {
                    detail: {
                        answer,
                    },
                    composed: true,
                    bubbles: true,
                })
            )
            this.shadowRoot
                .querySelector('.lora-short__overlay__mid-right.lora__actions')
                .classList.remove('lora--d-none')
        }

        this._qaInstance._clickedAnswerBtnCallback = (e) => {
            this.isInteracting = true
        }

        this._qaInstance._finishQACallback = () => {
            this.isInteracting = false
        }
    }

    hideProcessingOverlay() {
        const processingOverlay = this.shadowRoot.querySelector('.lora-short__wrapper__processing')
        processingOverlay.classList.add('hidden')
    }

    showProcessingOverlay() {
        const processingOverlay = this.shadowRoot.querySelector('.lora-short__wrapper__processing')
        processingOverlay.classList.remove('hidden')
    }

    connectedCallback() {
        this.getInitialData()
        this.render()
        this.checkIsInPipMode()
        this.yourOverfollowStyle = GlobalSettings.overflowStyle.bodyOverflow
    }

    disconnectedCallback() {
        this.videoElement = null
        window.removeEventListener('resize', this.calculatorLayoutFunction)
        clearTimeout(this.trackingViewTimer)
        this.unsubscribeAppContext()
        this.unsubscribeCurrentPlayingIndex()
        this.stopObseverTracking()
    }

    async attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'autoplay': {
                if (newValue !== null && newValue !== 'false') {
                    this.autoplay = true
                } else {
                    this.autoplay = false
                }
                break
            }
            case 'item-width': {
                if (newValue !== null) {
                    this.itemWidth = parseFloat(newValue)
                    if (this.calculatorLayoutFunction) {
                        this.calculatorLayoutFunction()
                    }
                }
                break
            }
            case 'video-height': {
                if (newValue) {
                    this.videoHeight = newValue
                    let wrapperItem = this.shadowRoot.querySelector('.lora-short__wrapper')
                    if (wrapperItem) {
                        wrapperItem.style.setProperty(
                            '--video-height',
                            this.videoHeight ? `${this.videoHeight}` : '480px'
                        )
                    }

                    if (this.calculatorLayoutFunction) {
                        this.calculatorLayoutFunction()
                    }
                }
                break
            }
            case 'custom-height': {
                if (newValue !== null && newValue !== 'false') {
                    this.useCustomHeight = true
                } else {
                    this.useCustomHeight = false
                }
                if (this.calculatorLayoutFunction) {
                    this.calculatorLayoutFunction()
                }
                break
            }

            case 'loop': {
                if (newValue !== null && newValue !== 'false') {
                    this.loop = true
                } else {
                    this.loop = false
                }
                break
            }
            case 'lazyload': {
                if (newValue !== null && newValue !== 'false') {
                    this.lazyload = true
                } else {
                    this.lazyload = false
                }
                break
            }
            case 'muted': {
                if (newValue == 'false') {
                    this.muted = false
                } else {
                    this.muted = true
                }
                break
            }
            case 'enable-fullscreen': {
                if (newValue !== null && newValue !== 'false') {
                    this.enableFullscreen = true
                } else {
                    this.enableFullscreen = false
                }
                break
            }
            case 'url': {
                if (!newValue && this.videoElement && newValue !== this.videoElement?.src) {
                    this.videoElement.src = newValue
                    this.videoElement?.load()
                }
            }
            case 'fullscreen': {
                if (this.calculatorLayoutFunction) {
                    this.calculatorLayoutFunction()
                }
            }
            case 'group': {
                if (newValue) {
                    this.group = newValue
                } else {
                    this.group = 'general'
                }
                if (this.videoElement) {
                    this.videoElement?.setAttribute('group', this.group)
                }
                break
            }
            case 'simple': {
                if (newValue !== null) {
                    this.isSimple = true
                } else {
                    this.isSimple = false
                }
                break
            }

            case 'processing': {
                if (newValue !== null && newValue !== 'false') {
                    this.isProcessing = true
                    this.showProcessingOverlay()
                } else {
                    this.isProcessing = false
                    this.hideProcessingOverlay()
                }
                break
            }

            case 'video-type': {
                if (newValue) {
                    if (
                        this.isFullscreen ||
                        newValue === this.videoType ||
                        Number(newValue) == 0 ||
                        this.playlistType === PLAYLIST_TYPE.STORY_BLOCK
                    )
                        return

                    this.videoType = newValue
                    this.videoTypeIcon =
                        this.videoType == OVERLAY_TYPE.CTA
                            ? this.ctaIcon
                            : this.videoType == OVERLAY_TYPE.POLLING
                            ? this.pollIcon
                            : this.videoType == OVERLAY_TYPE.QUESTION_AND_ANSWER
                            ? this.questionIcon
                            : null
                    // Add icon type short video
                    if (!this.videoTypeIcon) return
                    setTimeout(() => {
                        const iconImg = document.createElement('img')
                        const containerIcon = this.shadowRoot.querySelector('.lora-short__overlay__icon')

                        if (!containerIcon) return
                        iconImg.setAttribute('src', this.videoTypeIcon)
                        containerIcon.appendChild(iconImg)
                    }, 300)
                }
                break
            }

            case 'prev-index': {
                this.prevIndex = parseInt(newValue)
                break
            }
            case 'next-index': {
                this.nextIndex = parseInt(newValue)
                break
            }
            case 'pip-style': {
                this.pipStyle = newValue
                break
            }
            case 'active-index': {
                this.activeIndex = parseInt(newValue)
                this.checkImageAndObserve()
                break
            }
            case 'uuid': {
                this.uuid = newValue
                break
            }
            case 'disable-tracking': {
                this.disableTracking = newValue !== null && newValue !== 'false' ? true : false
                if (this.disableTracking) {
                    this.stopObseverTracking()
                } else {
                    this.checkImageAndObserve()
                }
                break
            }
            case 'tag-name': {
                this.customTagName = newValue
                break
            }
            case 'fs-force-new-tab': {
                if (newValue !== null && newValue !== 'false') {
                    this.isForceNewTab = true
                } else {
                    this.isForceNewTab = false
                }
                break
            }
            case 'min-h-btns': {
                this.minVideoHeightToShowButtons = this.parseMinHeightAttribute()
            }
            case 'is-liked-video': {
                if (newValue !== null && newValue !== 'false') {
                    this.isLikedVideo = true
                } else {
                    this.isLikedVideo = false
                }
                requestAnimationFrame(() => {
                    this.updateLikeIcon()
                    this.updateUIElement()
                })
                break
            }

            case 'enable-like-button': {
                if (newValue !== null && newValue !== 'false') {
                    this.enableLikeButton = true
                } else {
                    this.enableLikeButton = false
                }
                requestAnimationFrame(() => {
                    this.updateUIElement()
                })
                break
            }

            case 'display-like-count': {
                if (newValue !== null && newValue !== 'false') {
                    this.displayLikeCount = true
                } else {
                    this.displayLikeCount = false
                }
                requestAnimationFrame(() => {
                    this.updateUIElement()
                })
                break
            }

            case 'total-like': {
                this.totalLike = parseInt(newValue)
                requestAnimationFrame(() => {
                    this.updateUIElement()
                })
                break
            }
        }
    }

    getInitialData() {
        this.videoId = this.getAttribute('video-id')
        this.videoHeight = this.getAttribute('video-height') ? this.getAttribute('video-height') : '480px'
        this.url = this.getAttribute('url')
        this.title = this.getAttribute('title')
        this.featureImage = this.getAttribute('feature-image')
        this.loop = this.hasAttribute('loop') && this.getAttribute('loop') !== 'false' ? true : false
        this.currentIndex = this.getAttribute('data-index') ? parseInt(this.getAttribute('data-index')) : 0

        this.prevIndex = this.getAttribute('prev-index') ? parseInt(this.getAttribute('prev-index')) : 0

        this.nextIndex = this.getAttribute('next-index') ? parseInt(this.getAttribute('next-index')) : 0
        this.isFullscreen = this.getAttribute('fullscreen') !== null ? true : false
        this.isForceNewTab =
            this.hasAttribute('fs-force-new-tab') && this.getAttribute('fs-force-new-tab') !== 'false' ? true : false
        this.muted = this.getAttribute('muted') == 'false' ? false : true
        this.enableFullscreen = this.getAttribute('enable-fullscreen') == 'false' ? false : true
        this.wrapperLayout = this.getAttribute('wrapper') ? this.getAttribute('wrapper') : 'b-short-video'
        this.isSimple = this.getAttribute('simple') !== null ? true : false
        this.group = this.getAttribute('group') ? this.getAttribute('group') : 'general'
        this.pipStyle = this.getAttribute('pip-style') || 'bottom: 0px; right: 15px;'
        // Video opitons:
        this.autoplay = this.getAttribute('autoplay') !== null ? true : false

        this.itemWrapper = this.getAttribute('item-wrapper') ? this.getAttribute('item-wrapper') : ''
        this.gutters = this.getAttribute('gutters') ? parseFloat(this.getAttribute('gutters')) : 10
        this.itemWidth = this.getAttribute('item-width') ? parseFloat(this.getAttribute('item-width')) : 0
        this.isEmpty = this.getAttribute('empty') !== null ? true : false
        this.lazyload = this.getAttribute('lazyload') !== null ? true : false
        this.useCustomHeight = this.getAttribute('custom-height') !== null ? true : false
        this.organizationId = this.getAttribute('organization-id') ? parseInt(this.getAttribute('organization-id')) : 0
        this.customTagName = this.getAttribute('tag-name')

        this.enableLikeButton =
            this.hasAttribute('enable-like-button') && this.getAttribute('enable-like-button') !== 'false'
                ? true
                : false
        this.displayLikeCount =
            this.hasAttribute('display-like-count') && this.getAttribute('display-like-count') !== 'false'
                ? true
                : false
        this.totalLike = this.getAttribute('total-like') ? parseInt(this.getAttribute('total-like')) : 0

        this.minVideoHeightToShowButtons = this.parseMinHeightAttribute()

        this.wrapperContainer = this.shadowRoot.host.getRootNode().host

        this.videoType = this.getAttribute('video-type')
        this.uuid = this.getAttribute('uuid') || uuidv4()
        this.videoTypeIcon =
            this.videoType == OVERLAY_TYPE.CTA
                ? this.ctaIcon
                : this.videoType == OVERLAY_TYPE.POLLING
                ? this.pollIcon
                : this.videoType == OVERLAY_TYPE.QUESTION_AND_ANSWER
                ? this.questionIcon
                : null

        if (this.wrapperLayout !== 'b-short-video') {
            this.wrapperContainer = this.shadowRoot.host.getRootNode().host.getRootNode().host
        }
        this.playlistId = this.wrapperContainer.getAttribute('playlist-id')
        this.maxVideos = this.wrapperContainer.getAttribute('max-videos')
        this.isProcessing = this.getAttribute('processing') !== null ? true : false

        const playingIndex = $videoPlayingIndex.get()[this.playlistId || this.videoId]
        if (playingIndex !== undefined) {
            this.currentPlayingIndex = playingIndex
        }
    }

    // Parse the attribute to support both number and object formats
    parseMinHeightAttribute() {
        const attrValue = this.getAttribute('min-h-btns')

        if (!attrValue)
            return {
                fullscreen: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                share: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                timeline: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                overlay: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                title: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
            } // Default values

        if (/^\d+$/.test(attrValue)) {
            // If it's a number (like "256"), convert it to an integer for both buttons
            const minHeight = parseInt(attrValue, 10)
            return {
                fullscreen: minHeight,
                share: minHeight,
                timeline: minHeight,
                overlay: minHeight,
                title: minHeight,
            }
        }

        try {
            // If it's a JSON-like object (e.g., '{"fullscreen": 256, "share": 468}')
            const parsed = JSON.parse(attrValue)
            return {
                fullscreen: parsed.fullscreen ?? DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                share: parsed.share ?? DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                timeline: parsed.timeline ?? DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                overlay: parsed.overlay ?? DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                title: parsed.title ?? DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
            }
        } catch (e) {
            console.warn('Invalid format for min-h-btns:', attrValue)
            return {
                fullscreen: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                share: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                timeline: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                overlay: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
                title: DEFAULT_MIN_HEIGHT_TO_SHOW_BTN,
            } // Default fallback
        }
    }

    updateVideoData(data) {
        this.loaded = true
        this.url = data.url
        this.videoElement?.setAttribute('src', this.url)
        this.videoElement?.load()
        this.enableLikeButton = data?.enableLikeButton || false
        this.displayLikeCount = data?.displayLikeCount || false
        this.totalLike = parseInt(data?.totalLike) || 0
        this.isLikedVideo = data?.isLikedVideo || false
        this.updateUIElement()
        if (!data.isPreload || this.autoplay) {
            this.tryToPlayVideo()
        }
    }

    updateUIElement() {
        // Like layout
        const likeLayoutEl = this.shadowRoot.querySelector('.lora-short__like-layout')
        if (likeLayoutEl) {
            if (this.enableLikeButton) {
                likeLayoutEl.classList.add('lora--showing')
            } else {
                likeLayoutEl.classList.remove('lora--showing')
            }

            const likeValueEl = this.shadowRoot.querySelector('.lora-short__like-layout--value')
            if (likeValueEl) {
                if (this.displayLikeCount && this.totalLike) {
                    likeValueEl.textContent = helper.formatNumberToString(this.totalLike)
                    likeValueEl.classList.add('lora--showing')
                } else {
                    likeValueEl.classList.remove('lora--showing')
                }
            }

            const likeIconEl = this.shadowRoot.querySelector('.lora-short__like-layout--icon')
            if (likeIconEl) {
                if (this.isLikedVideo) {
                    likeIconEl.src = LikedIcon
                } else {
                    likeIconEl.src = LikeIcon
                }
            }
        }
    }

    registerEvents() {
        const wrapper = this.shadowRoot?.host?.getAttribute('wrapper')

        this.videoElement = this.shadowRoot.querySelector('video')
        this.videoContainer = this.shadowRoot.querySelector('.lora-short__wrapper')
        this.titleEl = this.shadowRoot.querySelector('.lora-short__title')

        this.registerLayout()
        this.registerRefreshButton()
        this.updateVideoAutoPlay(this.autoplay)
        this.registerVideoActions()
        this.registerVideoEvents()
        this.shareEvents()
        window.addEventListener('PIP_INFO', (event) => {
            const { isMuted, isPlaying } = event?.detail
            this.pipInfo = {
                isMuted: isMuted || true,
                isPlaying: isPlaying || false,
            }
            if (this.pipInfo.isPlaying && !this.videoElement?.paused) {
                this.videoElement?.pause()
            }
        })
        this.shadowRoot.dispatchEvent(
            new CustomEvent('sv-load', {
                detail: {},
                composed: true,
                bubbles: true,
            })
        )
        if (!this.isFullscreen) {
            this.checkPiPState()
        }
        if (wrapper) {
            this.playlistType = wrapper.includes('carousel')
                ? PLAYLIST_TYPE.CAROUSEL
                : wrapper.includes('grid')
                ? PLAYLIST_TYPE.GRID
                : wrapper.includes('story-block')
                ? PLAYLIST_TYPE.STORY_BLOCK
                : ''
            if (this.playlistType === PLAYLIST_TYPE.STORY_BLOCK) {
                const toggleSoundBtn = this.shadowRoot.querySelector('.lora-short--toggle-sound-btn-sm')
                if (!toggleSoundBtn) return
                toggleSoundBtn.classList.add('lora-short--toggle-sound-btn-story-block')
            }
        }
    }

    registerRefreshButton() {
        const refreshButton = this.shadowRoot.querySelector('.lora-short__wrapper__processing--button')
        if (!refreshButton) return
        refreshButton.addEventListener('click', (e) => {
            window.location.reload()
        })
    }

    registerLayout() {
        var onResizeLayout = function () {
            this.isPortrait = GlobalSettings.checkScreenIsPortrait()
            /** Function to get the width & height based on ratio 16:9 */
            let parentLayout = this.shadowRoot.host.parentElement
            let wrapperShortVideo = this.shadowRoot.querySelector('.lora-short__wrapper')
            let shortElement = this.shadowRoot.querySelector('.lora-short')
            let heightItem, widthItem, wrapperItem
            let parentHeight = parentLayout.clientHeight
            const loraShortVideo = this.shadowRoot.querySelector('.lora-short')

            if (!this.itemWidth && (!this.itemWrapper || this.itemWrapper == '.lora-fullscreen__main')) {
                // Single
                heightItem = parentHeight
                widthItem = (heightItem * 9) / 16
                if (this.isFullscreen) {
                    if (!this.isPortrait && this.videoWidthDimension > this.videoHeightDimension) {
                        // Landscape
                        heightItem = window.innerHeight
                        widthItem = (heightItem * this.videoWidthDimension) / this.videoHeightDimension
                        if (widthItem > window.innerWidth) {
                            widthItem = window.innerWidth
                            heightItem = (widthItem * this.videoHeightDimension) / this.videoWidthDimension
                        }
                        loraShortVideo.classList.add('landscape-mode')
                    } else {
                        if (widthItem > window.innerWidth) {
                            widthItem = window.innerWidth
                        } else {
                            widthItem = (window.innerHeight * 9) / 16
                            heightItem = (widthItem * 16) / 9
                        }
                    }
                } else {
                }
            } else if (!this.itemWrapper) {
                // Carousel | Story
                if (this.isFullscreen) {
                    if (!this.isPortrait && this.videoWidthDimension > this.videoHeightDimension) {
                        // Landscape
                        heightItem = window.innerHeight
                        widthItem = (heightItem * this.videoWidthDimension) / this.videoHeightDimension
                        if (widthItem > window.innerWidth) {
                            widthItem = window.innerWidth
                            heightItem = (widthItem * this.videoHeightDimension) / this.videoWidthDimension
                        }
                        loraShortVideo.classList.add('landscape-mode')
                    } else {
                        heightItem = window.innerHeight
                        widthItem = (window.innerHeight * 9) / 16
                        if (widthItem > window.innerWidth) {
                            widthItem = window.innerWidth
                        }
                    }
                } else if (helper.mediaBreakpointDown('xs') && this.isFullscreen) {
                    heightItem = window.innerHeight
                    widthItem = window.innerWidth
                } else {
                    heightItem = (this.itemWidth * 16) / 9
                    widthItem = (heightItem * 9) / 16
                }
            } else {
                // Grid
                wrapperItem = this.shadowRoot.host
                    .getRootNode()
                    .host.getRootNode()
                    .host.shadowRoot.querySelector(this.itemWrapper)
                if (this.useCustomHeight) {
                    heightItem = this.videoHeight
                    widthItem = (heightItem * 9) / 16
                } else {
                    widthItem = wrapperItem.clientWidth - 2 * this.gutters
                    heightItem = (widthItem * 16) / 9
                }
            }

            shortElement.style.width = `${widthItem}px`
            shortElement.style.height = `${heightItem}px`
            wrapperShortVideo.style.width = `${widthItem}px`
            wrapperShortVideo.style.height = `${heightItem}px`
            wrapperShortVideo.style.setProperty('--wrapper-height', `${heightItem}px`)
            wrapperShortVideo.style.setProperty('--wrapper-width', `${widthItem}px`)
            this.checkToShowActionBtn(heightItem)
            if (widthItem >= 768) {
                shortElement.classList.add('desktop-version')
            } else {
                shortElement.classList.remove('desktop-version')
            }
            this.checkImageAndObserve()
        }
        this.calculatorLayoutFunction = onResizeLayout.bind(this)
        window.addEventListener('resize', this.calculatorLayoutFunction)
        this.calculatorLayoutFunction()
    }

    checkToShowActionBtn(heightItem) {
        const meetsMinHeightForFullscreen = heightItem >= this.minVideoHeightToShowButtons?.fullscreen
        // Update layout
        const fullscreenBtnEl = this.shadowRoot.querySelector('.lora-short--fs-btn')
        if (fullscreenBtnEl) {
            if (meetsMinHeightForFullscreen) {
                fullscreenBtnEl.classList.remove('lora--d-none')
            } else {
                fullscreenBtnEl.classList.add('lora--d-none')
            }
        }

        const meetsMinHeightForShare = heightItem >= this.minVideoHeightToShowButtons?.share
        // Update layout
        const shareBtnEl = this.shadowRoot.querySelector('.lora-short--share-btn')
        if (shareBtnEl) {
            if (meetsMinHeightForShare) {
                shareBtnEl.classList.remove('lora--d-none')
            } else {
                shareBtnEl.classList.add('lora--d-none')
            }
        }

        const meetsMinHeightForTimeline = heightItem >= this.minVideoHeightToShowButtons?.timeline
        // Update layout
        const timelineEl = this.shadowRoot.querySelector('.lora__timeline-progress')
        if (timelineEl) {
            if (meetsMinHeightForTimeline) {
                timelineEl.classList.remove('lora--d-none')
            } else {
                timelineEl.classList.add('lora--d-none')
            }
        }

        const meetsMinHeightForTitle = heightItem >= this.minVideoHeightToShowButtons?.title
        // Update layout
        const titleEl = this.shadowRoot.querySelector('.lora-short__title')
        if (titleEl) {
            if (meetsMinHeightForTitle) {
                titleEl.classList.remove('lora--d-none')
            } else {
                titleEl.classList.add('lora--d-none')
            }
        }

        const meetsMinHeightForOverlayIcon = heightItem >= this.minVideoHeightToShowButtons?.overlay
        // Update layout
        const overlayIconEl = this.shadowRoot.querySelector('.lora-short__overlay__icon')
        if (overlayIconEl) {
            if (meetsMinHeightForOverlayIcon) {
                overlayIconEl.classList.remove('lora--d-none')
            } else {
                overlayIconEl.classList.add('lora--d-none')
            }
        }

        // Update layout
        const overlayLayoutEl = this.shadowRoot.querySelector('.lora-short__overlay__mid-left')
        if (overlayLayoutEl) {
            if (meetsMinHeightForOverlayIcon) {
                overlayLayoutEl.classList.remove('lora--d-none')
            } else {
                overlayLayoutEl.classList.add('lora--d-none')
            }
        }

        const overlayRightLayout = this.shadowRoot.querySelector('.lora-short__overlay__mid-right')
        if (overlayRightLayout) {
            if (meetsMinHeightForOverlayIcon) {
                overlayRightLayout.classList.remove('lora--mb-0')
            } else {
                overlayRightLayout.classList.add('lora--mb-0')
            }
        }
    }

    updateVideoMuteState() {
        const toggleSoundBtn = this.shadowRoot.querySelector('.lora-short--toggle-sound-img')
        if (!toggleSoundBtn) return
        if (this.videoElement?.muted) {
            toggleSoundBtn.src = this.muteIcon
        } else {
            toggleSoundBtn.src = this.unMuteIcon
        }
    }

    updateVideoAutoPlay(autoplay = true) {
        if (!this.videoElement) {
            return
        }
        if (autoplay) {
            if (this.loaded) {
                this.tryToPlayVideo()
            }
        } else {
            if (this.loaded) {
                this.videoElement.currentTime = 0
                this.videoElement?.pause()
                this.videoContainer.classList.remove('playing')
                this.videoContainer.classList.remove('black-bg')
            }
        }
    }

    pauseOtherVideos() {
        const loraComponents = [
            'b-fullscreen',
            'video-embed',
            'carousel-playlist',
            'grid-playlist',
            'story-block-playlist',
        ]
        let fullscreenVideoFound = false

        // First, check if there's a video inside b-fullscreen and prioritize it
        loraComponents.forEach((loraComponent) => {
            const loraVideoComponents = document.querySelectorAll(loraComponent)
            loraVideoComponents.forEach((loraVideo) => {
                helper.selectAllVideosInShadowDOM(loraVideo, this.group, (videoElement) => {
                    // If a video is found inside b-fullscreen, it should continue playing
                    if (loraComponent === 'b-fullscreen' && videoElement === this.videoElement) {
                        fullscreenVideoFound = true
                        videoElement.play() // Ensure the video inside b-fullscreen continues playing
                    } else if (!fullscreenVideoFound && videoElement !== this.videoElement) {
                        // Pause all other videos except the current one
                        videoElement.pause()
                    } else if (fullscreenVideoFound && loraComponent !== 'b-fullscreen') {
                        // If a video inside b-fullscreen is playing, pause all others
                        // Pause all other videos except the current one
                        videoElement.pause()
                    }
                })
            })
        })
    }

    registerVideoActions() {
        this.videoContainer = this.shadowRoot.querySelector('.lora-short__wrapper')
        if (this.url) {
            this.loaded = true
        }
        this.videoElement.controls = false
        this.videoElement.muted = this.muted
        this.videoElement?.setAttribute('group', this.group)
        if (!this.isFullscreen) {
            this.shadowRoot.querySelector('.lora-short__overlay').addEventListener('click', (event) => {
                event.stopPropagation()
                this.switchToFullscreen()
            })
        }
        const isMobile =
            window.matchMedia('(any-pointer:coarse)').matches && window.matchMedia('(any-pointer:coarse)').matches

        const showPlayButtonAndSeekBar = () => {
            this.shadowRoot
                .querySelector('.lora-short__overlay__hover')
                .classList.remove('lora--d-none', 'lora--hidden')
            if (!this.isSimple) {
                this.shadowRoot.querySelector('.lora-short__overlay__bot').classList.remove('lora--hidden')
            }
        }

        const debounceHidePlayButtonAndSeekBar = helper.debounce(() => {
            this.shadowRoot.querySelector('.lora-short__overlay__hover').classList.add('lora--d-none', 'lora--hidden')
            if (!this.isSimple) {
                this.shadowRoot.querySelector('.lora-short__overlay__bot').classList.add('lora--hidden')
            }
        }, 3000)

        this.shadowRoot.querySelector('.lora-short__wrapper').onmouseenter = () => {
            if (isMobile) return

            showPlayButtonAndSeekBar()
            this.initHoverPlayVideo()
        }

        this.shadowRoot.querySelector('.lora-short__wrapper').ontouchstart = (event) => {
            this.startX = event.touches[0].clientX
            this.startY = event.touches[0].clientY

            this.initHoverPlayVideo()
        }

        const overlayMain = this.shadowRoot.querySelector('.lora-short__overlay__main')
        if (overlayMain) {
            overlayMain.ontouchstart = (event) => {
                showPlayButtonAndSeekBar()
                debounceHidePlayButtonAndSeekBar()
            }
        }

        this.shadowRoot.querySelector('.lora-short__wrapper').ontouchend = (event) => {
            this.endX = event.changedTouches[0].clientX
            this.endY = event.changedTouches[0].clientY

            const MINIMUM_PIXELS_SCROLL = 20
            const distance = this.isFullscreen ? Math.abs(this.endY - this.startY) : Math.abs(this.endX - this.startX)
            if (isMobile && distance > MINIMUM_PIXELS_SCROLL) {
                clearTimeout(this.hoverTimer)
            }
        }
        // }

        this.shadowRoot.querySelector('.lora-short__wrapper').onmouseleave = (event) => {
            if (isMobile) return

            clearTimeout(this.hoverTimer)
            debounceHidePlayButtonAndSeekBar()
        }
        // }

        // Play / Pause action
        const stateVideoElement = this.shadowRoot.querySelector('.lora-short__state-img')
        const videoActionEl = this.shadowRoot.querySelector('.lora-short__overlay__hover')
        if (stateVideoElement && videoActionEl) {
            videoActionEl.addEventListener('click', (e) => {
                e.stopPropagation()
                if (this.videoElement?.paused) {
                    this.tryToPlayVideo()
                } else {
                    this.videoElement?.pause()
                }
                clearTimeout(this.hoverTimer)
            })
        }

        // Mute / Un-mute action
        const toggleSoundBtn = this.shadowRoot.querySelector('.lora-short--toggle-sound-btn')
        if (toggleSoundBtn) {
            toggleSoundBtn.addEventListener('click', this.toggleSound)
        }

        // Share action
        const shareBtn = this.shadowRoot.querySelector('.lora-short--share-btn')
        helper.stopPropagationTouchEvent(shareBtn)
        if (shareBtn) {
            shareBtn.addEventListener('click', (event) => {
                event.stopPropagation()
                this.shadowRoot.querySelector('.lora-short__overlay__info').classList.add('lora--visible')
                this.shadowRoot
                    .querySelector('.lora-short__overlay__main')
                    .classList.add('lora--d-none', 'lora--hidden')
                this.shadowRoot
                    .querySelector('.lora-short__overlay__hover')
                    .classList.add('lora--d-none', 'lora--hidden')
            })
        }

        // Like action
        const likeBtn = this.shadowRoot.querySelector('.lora-short__like-layout--btn')
        if (likeBtn) {
            helper.stopPropagationTouchEvent(likeBtn)
            likeBtn.addEventListener('click', (event) => {
                event.stopPropagation()
                if (this.enableLikeButton) {
                    this.toggleLikeVideo()
                }
            })
        }

        if (!this.isFullscreen) {
            // Fulllscreen action
            const fullscreenBtn = this.shadowRoot.querySelector('.lora-short--fs-btn')
            if (fullscreenBtn) {
                fullscreenBtn.addEventListener('click', (event) => {
                    event.stopPropagation()
                    this.switchToFullscreen()
                })
            }
        } else {
            // Exit fullscreen action
            const exitFsBtn = this.shadowRoot.querySelector('.lora-short--exit-fs-btn')
            if (exitFsBtn) {
                exitFsBtn.addEventListener('click', (event) => {
                    event.stopPropagation()
                    if (this.isCurrentOrigin) {
                        this.shadowRoot.dispatchEvent(
                            new CustomEvent('exit-fullscreen', {
                                detail: {},
                                composed: true,
                                bubbles: true,
                            })
                        )
                        window.close()
                    } else {
                        this.exitFullscreenMode()
                    }
                })
            }

            // PIP action
            const pipBtn = this.shadowRoot.querySelector('.lora-short--pip-btn')
            if (pipBtn) {
                pipBtn.addEventListener('click', (event) => {
                    event.stopPropagation()
                    this.switchToPip()
                    this.exitFullscreenMode()
                })
            }
        }
    }

    initHoverPlayVideo() {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = setTimeout(() => {
            if (
                !this.noActionHover &&
                !this.pipMode &&
                !this.isFullscreen &&
                (this.videoElement?.paused || this.videoElement?.ended)
            ) {
                if (this.lazyload) {
                    this.shadowRoot.dispatchEvent(
                        new CustomEvent('fetch-detail', {
                            detail: {},
                            composed: true,
                            bubbles: true,
                        })
                    )
                } else {
                    if (!this.videoElement?.src) {
                        this.reloadVideo()
                    }
                    this.tryToPlayVideo()
                    this.shadowRoot
                        .querySelector('.lora-short__overlay__hover')
                        .classList.add('lora--d-none', 'lora--hidden')
                }
            }
        }, 1000)
    }

    tryToPlayVideo() {
        if (!this.isDisplaying) {
            return
        }
        // Show loading animation.
        var playPromise = this.videoElement?.play()

        if (playPromise !== undefined) {
            playPromise
                .then((_) => {
                    // Automatic playback started!
                    // Show playing UI.
                    this.videoContainer.classList.add('playing')
                    this.videoContainer.classList.add('black-bg')
                    // this.hideThumbnail();
                })
                .catch((error) => {
                    // this.videoElement?.muted = true;
                    // this.videoElement?.play();
                })
        }
    }

    switchToFullscreen(attrs = {}) {
        if (!this.enableFullscreen) {
            return
        }
        this.removeCurrentPipStates()
        this.trackingFullscreen()

        let playlistId
        if (this.wrapperContainer) {
            this.wrapperContainer.classList.add('in-fs')
            playlistId = this.wrapperContainer.getAttribute('playlist-id')
        }
        if (this.isForceNewTab || helper.isInIframe()) {
            const props = {
                videoId: this.videoId,
                current: this.currentIndex,
                loop: this.loop ? 'true' : 'false',
            }
            if (playlistId) props.playlistId = playlistId
            helper.redirectShortVideoOrigin(props)
            return
        }

        const el = document.createElement('b-fullscreen')
        el.setAttribute('video-id', this.videoId)
        el.setAttribute('pip-style', this.pipStyle)
        el.setAttribute('uuid', this.uuid)
        el.setAttribute('tag-name', this.customTagName)
        for (let prop in attrs) {
            el.setAttribute(prop, attrs[prop])
        }
        if (playlistId) {
            this.wrapperContainer.classList.add('is-playlist')
            el.setAttribute('playlist-id', playlistId)
            el.setAttribute('current-index', this.currentIndex)
            el.setAttribute('playlist-type', this.playlistType)
            // Check loop from start by attribute of playlist container, not by this.loop variable
            if (this.wrapperContainer.hasAttribute('loop') && this.wrapperContainer.getAttribute('loop') !== 'false') {
                el.setAttribute('loop', '')
            }

            if (this.playlistType == PLAYLIST_TYPE.GRID && this.maxVideos != 0) {
                el.setAttribute('max-videos', this.maxVideos)
            }
        }
        document.body.appendChild(el)
        this.fullscreenInternalEvents(el)
    }

    fullscreenInternalEvents(el) {
        el.eventManager.on(MANUAL_CART_EVENTS.SYNC_PRODUCT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_PRODUCT, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.ADD_TO_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.ADD_TO_CART, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.UPDATE_ITEM_IN_CART, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.SYNC_CART_STATE, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.SYNC_CART_STATE, data, callback)
        })

        el.eventManager.on(MANUAL_CART_EVENTS.CHECKOUT, (data, callback) => {
            this.eventManager.emit(MANUAL_CART_EVENTS.CHECKOUT, data, callback)
        })
    }

    removeCurrentPipStates() {
        let inFsElements = document.querySelectorAll('.in-fs')
        inFsElements.forEach((inFsElement) => {
            let videoEmbed = inFsElement
            let pipId = inFsElement.getAttribute('data-pip')
            if (pipId && inFsElement.classList.contains('is-playlist')) {
                videoEmbed = inFsElement.shadowRoot.querySelector(`video-embed[video-id="${pipId}"]`)
            }
            if (videoEmbed) {
                videoEmbed.shadowRoot
                    .querySelector('b-short-video')
                    ?.shadowRoot.querySelector('.lora-short__pip-overlay')
                    .classList.add('lora--hidden')
            }
            inFsElement.classList.remove('in-fs')
            inFsElement.removeAttribute('data-pip')
        })
        let pipElements = document.querySelectorAll('b-pip')
        pipElements.forEach((el) => {
            el.remove()
        })
    }

    switchToPip() {
        window.dispatchEvent(
            new CustomEvent('PIP_INFO', {
                detail: {
                    isMuted: false,
                    isPlaying: true,
                },
                composed: true,
                bubbles: true,
            })
        )
        return new Promise((resolve) => {
            let inFsElements = document.querySelectorAll('.in-fs')
            let pipElements = document.querySelectorAll('b-pip')
            pipElements.forEach((pipElement) => {
                pipElement.remove()
            })
            const el = document.createElement('b-pip')
            el.setAttribute('src', this.url)
            el.setAttribute('color-primary', '#acacac')
            el.setAttribute('size', '0% 100%')
            el.setAttribute('video-id', this.videoId)
            el.setAttribute('organization-id', this.organizationId)
            el.setAttribute('uuid', this.uuid)
            el.setAttribute('duration', this.duration)
            el.setAttribute('current', this.currentIndex)
            el.setAttribute('muted', this.videoElement ? this.videoElement?.muted : false)
            el.setAttribute('pip-style', this.pipStyle)
            const currentTime = this.videoElement ? this.videoElement?.currentTime : 0
            el.setAttribute('playing-time', currentTime)
            document.body.appendChild(el)
            Cookies.set('lora-embed-pip--playing-time', currentTime)
            Cookies.set('lora-embed-pip', this.url)
            Cookies.set('lora-embed-pip--duration', this.duration)
            Cookies.set('lora-embed-pip--duration-string', this.durationString)
            Cookies.set('lora-embed-pip--audio', this.videoElement ? this.videoElement?.muted : false)
            Cookies.set('lora-embed-pip--position', this.pipStyle)
            if (this.wrapperContainer) {
                this.playlistId = this.wrapperContainer.getAttribute('playlist-id')
                if (this.playlistId) {
                    el.setAttribute('playlist-id', this.playlistId)
                    el.setAttribute('playlist-type', this.playlistType)
                    Cookies.set('lora-embed-pip--playlist-id', this.playlistId)
                    Cookies.set('lora-embed-pip--current', this.currentIndex)
                    Cookies.set('lora-embed-pip--loop', this.loop ? 'true' : 'false')
                }
            }
            Cookies.set('lora-embed-pip--video-id', this.videoId)
            Cookies.set('lora-embed-pip--organization-id', this.organizationId)
            inFsElements.forEach((inFsElement) => {
                let videoEmbed = inFsElement
                if (inFsElement.classList.contains('is-playlist')) {
                    videoEmbed = inFsElement.shadowRoot.querySelector(`video-embed[video-id="${this.videoId}"]`)
                }
                if (videoEmbed) {
                    inFsElement.setAttribute('data-pip', this.videoId)
                    const shortVideoElement = videoEmbed.shadowRoot.querySelector('b-short-video')
                    if (shortVideoElement) {
                        shortVideoElement.shadowRoot
                            .querySelector('.lora-short__pip-overlay')
                            .classList.remove('lora--hidden')
                    }
                }
            })
            // Resolve the promise after PIP setup is done
            resolve()
        })
    }

    checkPiPState() {
        let pipPlaylistId = Cookies.get('lora-embed-pip--playlist-id')
        let pipVideoId = Cookies.get('lora-embed-pip--video-id')
        if (this.wrapperContainer) {
            if (this.wrapperLayout !== 'b-short-video') {
                this.playlistId = this.wrapperContainer.getAttribute('playlist-id')
                if (this.playlistId === pipPlaylistId && pipVideoId === this.videoId) {
                    this.wrapperContainer.classList.add('in-fs', 'is-playlist')
                    this.wrapperContainer.setAttribute('data-pip', this.videoId)
                    this.shadowRoot.querySelector('.lora-short__pip-overlay').classList.remove('lora--hidden')
                }
            } else {
                if (pipVideoId === this.videoId) {
                    // pip state
                    this.wrapperContainer.classList.add('in-fs')
                    this.wrapperContainer.setAttribute('data-pip', this.videoId)
                    this.shadowRoot.querySelector('.lora-short__pip-overlay').classList.remove('lora--hidden')
                }
            }
        }
    }

    exitFullscreenMode() {
        this.shadowRoot.dispatchEvent(
            new CustomEvent('exit-fullscreen', {
                detail: {
                    videoId: this.videoId,
                    playlistId: this.playlistId,
                    uuid: this.uuid,
                },
                composed: true,
                bubbles: true,
            })
        )
        window.dispatchEvent(
            new CustomEvent('EXIT_FULLSCREEN', {
                detail: {
                    videoId: this.videoId,
                    playlistId: this.playlistId,
                    uuid: this.uuid,
                },
                composed: true,
                bubbles: true,
            })
        )
        resetAllState(this._videoItem.id)
        document.body.style.overflow = this.yourOverfollowStyle
        let fsElements = document.querySelectorAll('b-fullscreen')
        fsElements.forEach((fsElement) => {
            fsElement.remove()
        })
    }

    trackingViewPercent(roundedPercent) {
        this.shadowRoot.dispatchEvent(
            new CustomEvent('tracking-view-percent', {
                detail: roundedPercent,
                composed: true,
                bubbles: true,
            })
        )
    }

    updateLikeIcon() {
        // Like icon element
        const likeIconEl = this.shadowRoot.querySelector('.lora-short__like-layout--icon')
        if (likeIconEl) {
            if (this.isLikedVideo) {
                likeIconEl.src = this.likedIcon
            } else {
                likeIconEl.src = this.likeIcon
            }
        }
    }

    toggleLikeVideo() {
        this.shadowRoot.dispatchEvent(
            new CustomEvent('toggle-like-video', {
                detail: {},
                composed: true,
                bubbles: true,
            })
        )
    }

    showThumbnail() {
        const backgroundEl = this.shadowRoot.querySelector('.lora-short__bg')
        backgroundEl.style.transitionProperty = 'none'
        backgroundEl.classList.remove('faded')
        this.isHidingThumbnail = false
    }

    hideThumbnail() {
        const backgroundEl = this.shadowRoot.querySelector('.lora-short__bg')
        backgroundEl.style.transitionProperty = 'all 0.5s'
        backgroundEl.classList.add('faded')
        this.isHidingThumbnail = true
    }

    isFirstFrameLoaded() {
        return this.videoElement?.readyState >= 1 // readyState 1 indicates that metadata has been loaded
    }

    // Function to check if video is ready to play without error
    isVideoReady() {
        return this.videoElement?.readyState === 4 && !this.videoElement?.error
    }

    getCurrentVideoPercent() {
        let currentTime = this.videoElement?.currentTime

        // calculator progress percent
        let progressPercent = 0
        if (this.videoElement?.duration && currentTime) {
            progressPercent = Math.floor((currentTime * 100) / this.videoElement?.duration)
        }
        // Track play video
        const roundedPercent = Math.floor(progressPercent / 10) * 10
        return roundedPercent
    }

    minimizeOverlay() {
        if (this._qaInstance) {
            this._qaInstance.renderQaMinimizedLayout()
        } else if (this._pollInstance) {
            this._pollInstance.renderPollMinimizedLayout()
        }
    }

    registerVideoEvents() {
        this.shadowRoot.addEventListener('seeking-video', (event) => {
            this.isSeekingVideo = event.detail
        })

        // As the video is playing, update the progress bar
        this.videoElement.addEventListener('timeupdate', () => {
            if (this.isSeekingVideo) {
                return
            }

            const currentTime = this.videoElement?.currentTime
            const roundedPercent = this.getCurrentVideoPercent()

            this.trackingViewPercent({
                video_current_time: currentTime,
                video_percent: roundedPercent,
                video_duration: this.videoElement?.duration,
            })
        })
        this.videoElement.addEventListener('canplaythrough', () => {
            if (this.autoplay) {
                // this.tryToPlayVideo()
            }
        })

        // Check video state on various events
        this.videoElement.addEventListener('canplay', () => {
            if (this.isVideoReady()) {
                // this.hideThumbnail()
            }
        })

        this.unsubscribeCurrentPlayingIndex = $videoPlayingIndex.subscribe(async (videoPlayingIndexContext) => {
            const currentPlayingIndex = videoPlayingIndexContext[this.playlistId || this.videoId]

            if (
                !this.loaded ||
                !this.videoElement ||
                currentPlayingIndex === undefined ||
                this.currentPlayingIndex === currentPlayingIndex
            )
                return

            this.currentPlayingIndex = currentPlayingIndex

            if (this.currentPlayingIndex !== this.currentIndex) {
                this.minimizeOverlay()
            }

            const loadVideoIndex = [this.currentPlayingIndex]
            if (loadVideoIndex.includes(this.currentIndex)) {
                await this.reloadVideo()
                this.videoElement?.pause()
            } else {
                this.unloadVideo()
                this.showThumbnail()
            }
        })

        // Wait for the video's meta data to be loaded, then set the progress bar's max value to the duration of the video
        this.videoElement.addEventListener('loadedmetadata', () => {
            if (this.videoElement?.duration) {
                this.duration = this.videoElement?.duration
                this.durationString = helper.formatVideoTime(Math.floor(this.duration))
            }
            this.videoWidthDimension = this.videoElement?.videoWidth
            this.videoHeightDimension = this.videoElement?.videoHeight

            this.isPortrait = GlobalSettings.checkScreenIsPortrait()

            if (this.calculatorLayoutFunction) {
                this.calculatorLayoutFunction()
            }

            if (this.isFirstFrameLoaded()) {
                // this.hideThumbnail()
            }
            // if (this.autoplay) {
            // 	this.tryToPlayVideo()
            // }
        })

        // Pause event handle
        this.videoElement.addEventListener('pause', () => {
            clearTimeout(this.trackingViewTimer)
            this.trackingViewTimer = null
            this.shadowRoot.querySelector('.lora-short__state-img').src = this.playingIcon

            this.shadowRoot.dispatchEvent(
                new CustomEvent('video-pause', {
                    detail: {},
                    composed: true,
                    bubbles: true,
                })
            )
            if (!this.isFullscreen) {
                this.hideToggleSoundOnNonFullscreen()
                this.titleEl.classList.remove('lora--hidden')
            }
        })

        this.videoElement.addEventListener('playing', () => {
            this.isPlayed = true
            if (!this.isHidingThumbnail) {
                this.hideThumbnail()
            }
            if (!this.isFullscreen) {
                this.titleEl.classList.add('lora--hidden')
            }
        })

        // Play event handle
        this.videoElement.addEventListener('play', () => {
            if (!this.trackingViewTimer) {
                this.trackingViewTimer = setTimeout(() => {
                    this.trackingView()
                }, TIMEOUT_TRACKING)
            }
            this.pauseOtherVideos()
            this.shadowRoot.dispatchEvent(
                new CustomEvent('video-play', {
                    detail: {},
                    composed: true,
                    bubbles: true,
                })
            )
            this.shadowRoot.querySelector('.lora-short__state-img').src = this.pauseIcon
            if (!this.isFullscreen) {
                this.showToggleSoundOnNonFullscreen()
            }

            if (!this.isSimple) {
                this.shadowRoot.querySelector('.lora-short__actions__top').classList.remove('lora--hidden')
                this.shadowRoot.querySelector('.lora-short__overlay__mid').classList.remove('lora--hidden')
                this.shadowRoot.querySelector('.lora-short__actions__top').classList.add('lora--hover')
                this.shadowRoot.querySelector('.lora-short__overlay__mid').classList.add('lora--hover')
            }
        })

        this.videoElement.onplaying = async () => {
            if ($appContext.get()['video'].muted !== this.videoElement?.muted) {
                this.videoElement.muted = $appContext.get()['video'].muted
                this.muted = this.videoElement?.muted
            }
            if (this.isFullscreen) {
                const pipState = getContextValueByKey('pip')
                if (pipState.videoId === this.videoId && pipState.currentTime > 0) {
                    this.videoElement.currentTime = pipState.currentTime
                }
                updateAppContext('pip', {
                    videoId: undefined,
                    playlistId: undefined,
                    uuid: undefined,
                    currentTime: 0,
                })
            }
            this.updateVideoMuteState()
        }

        // Volume change event handle
        this.videoElement.onvolumechange = () => {
            this.updateVideoMuteState()
        }

        this.videoElement.addEventListener('ended', this.handleEndedVideo.bind(this))
    }

    handleEndedVideo() {
        if (this.isFullscreen) {
            let currentIndex = this.wrapperContainer.getAttribute('current')
                ? parseInt(this.wrapperContainer.getAttribute('current'))
                : 0
            let maxIndex = this.wrapperContainer.getAttribute('max-index')
                ? parseInt(this.wrapperContainer.getAttribute('max-index'))
                : 0
            let nextIndex = currentIndex + 1
            let hasLoop =
                this.wrapperContainer.hasAttribute('loop') && this.wrapperContainer.getAttribute('loop') !== 'false'
                    ? true
                    : false
            if (nextIndex > maxIndex) {
                if (hasLoop) {
                    if (!maxIndex) {
                        this.tryToPlayVideo()
                    }
                    nextIndex = 0
                } else {
                    return
                }
            }
            // Prevent scroll to next video when user is interacting(QA/Poll) with video
            if (this.isInteracting) {
                this.videoElement?.play()
                this.videoContainer.classList.add('playing')
                this.videoContainer.classList.add('black-bg')
                return
            }
            this.wrapperContainer.setAttribute('current', nextIndex)
        } else {
            if (this.loop) {
            }
        }
    }

    async reloadVideo(autoPlay = true) {
        if (this.videoElement) {
            this.videoElement?.setAttribute('src', this.url)
            this.videoElement?.load()
            if (autoPlay) {
                this.videoElement?.play().catch(() => {})
            } else {
                this.videoElement?.pause()
            }
        }
    }

    unloadVideo() {
        this.videoElement?.pause()
        this.videoElement?.removeAttribute('src') // empty source
        this.videoElement?.load()
        this.videoElement?.pause()
        this.isPlayed = false
    }

    trackingView() {
        const currentTime = this.videoElement?.currentTime
        const roundedPercent = this.getCurrentVideoPercent()
        this.shadowRoot.dispatchEvent(
            new CustomEvent('tracking-view', {
                detail: {
                    video_current_time: currentTime,
                    video_percent: roundedPercent,
                    video_duration: this.videoElement?.duration,
                },
                composed: true,
                bubbles: true,
            })
        )
    }

    trackingFullscreen() {
        this.shadowRoot.dispatchEvent(
            new CustomEvent('tracking-fullscreen', {
                detail: {},
                composed: true,
                bubbles: true,
            })
        )
    }

    shareEvents() {
        this.shadowRoot.addEventListener('share-cancel', () => {
            this.shadowRoot.querySelector('.lora-short__overlay__info').classList.remove('lora--visible')
            this.shadowRoot.querySelector('.lora-short__overlay__main').classList.remove('lora--d-none', 'lora--hidden')
        })
    }

    showToggleSoundOnNonFullscreen() {
        const toggleSoundBtn = this.shadowRoot.querySelector('.lora-short--toggle-sound-btn-sm')
        if (!toggleSoundBtn) return
        toggleSoundBtn.classList.remove('lora--hidden')
        toggleSoundBtn.addEventListener('click', this.toggleSound)
    }

    hideToggleSoundOnNonFullscreen() {
        const toggleSoundBtn = this.shadowRoot.querySelector('.lora-short--toggle-sound-btn-sm')
        if (!toggleSoundBtn) return
        toggleSoundBtn.classList.add('lora--hidden')
        toggleSoundBtn.removeEventListener('click', this.toggleSound)
    }

    async render() {
        var context = {
            autoplay: this.autoplay,
            videoHeight: this.videoHeight,
            videoId: this.videoId,
            url: this.url,
            title: this.title,
            playingIcon: this.playingIcon,
            featureImage: `url(${this.featureImage})`,
            muteIcon: this.muteIcon,
            unMuteIcon: this.unMuteIcon,
            fullscreenIcon: this.fullscreenIcon,
            pipIcon: this.pipIcon,
            closeIcon: this.closeIcon,
            shareIcon: this.shareIcon,
            logoIcon: this.logoIcon,
            isFullscreen: this.isFullscreen,
            dangerIcon: this.dangerIcon,
            playRectIcon: this.playRectIcon,
            isEmpty: this.isEmpty,
            group: this.group,
            isSimple: this.isSimple,
            isComplex: !this.isSimple,
            isProcessing: this.isProcessing,
            showPipButton: !this.isCurrentOrigin,
            videoTypeIcon: this.videoTypeIcon,
            maxVideos: this.maxVideos,
            enableFullscreen: this.enableFullscreen,
            pipStyle: this.pipStyle,
            uuid: this.uuid,
            likeIcon: this.likeIcon,
            likedIcon: this.likedIcon,
            enableLikeButton: this.enableLikeButton,
            displayLikeCount: this.displayLikeCount && this.totalLike,
            totalLike: helper.formatNumberToString(this.totalLike),
            isLikedVideo: this.isLikedVideo,
        }
        this.shadowRoot.innerHTML = `${layoutTemplate(context)}`
        //Append outside style
        const templateStyle = document.querySelector('template#lora-short-video')
        if (templateStyle) this.shadowRoot.appendChild(templateStyle.content.cloneNode(true))
        helper.appendCommonStyling(this.shadowRoot)
        this.registerEvents()
    }
}
window.customElements.define('b-short-video', ShortVideo)
